
import vars from "@exovera/narrative-tracker-variables";

//
// Entity Types
//
export const ENTITY_TYPE_ALL = "all";
export const ENTITY_TYPE_ORG = "organization";
export const ENTITY_TYPE_PERSON = "person";
export const ENTITY_TYPE_VESSEL = "vessel";

export const ENTITY_TYPE_LABEL_ALL = "All";
export const ENTITY_TYPE_LABEL_ORGS = "Orgs";
export const ENTITY_TYPE_LABEL_PEOPLE = "People";
export const ENTITY_TYPE_LABEL_VESSELS = "Vessels";

//
// Entity Attributes
//
export const ATTR_ADDRESS = "address";
export const ATTR_ADDRESS_EN = "address_en";
export const ATTR_AKA = "aka"; // array
export const ATTR_AKA_EN = "aka_en"; // array
export const ATTR_CALL_SIGN = "call_sign"; // array
export const ATTR_CATEGORIES = "categories"; // array
export const ATTR_CITIZENSHIP = "citizenship";
export const ATTR_CREATION_SOURCE = "creation_source";
export const ATTR_DETAILS = "details";
export const ATTR_DOB = "date_of_birth"; // array
export const ATTR_EMAIL = "email"; // array
export const ATTR_ENTITY_TYPE = "entity_type";
export const ATTR_EU_REF_NUM = "EU_ref_num"; // array
export const ATTR_FED_REGISTER_NOTICE = "fed_register_notice"; // array
export const ATTR_FKA = "fka"; // array
export const ATTR_FKA_EN = "fka_en"; // array
export const ATTR_FLAG_STATE = "flag_state"; // array
export const ATTR_FORMER_FLAG_STATE = "former_flag_state"; // array
export const ATTR_GROSS_TONNAGE = "gross_tonnage"; // array 
export const ATTR_ID = "id"; 
export const ATTR_IMO = "imo"; // array
export const ATTR_LABEL = "label";
export const ATTR_LABEL_EN = "label_en";
export const ATTR_LAST_EDITED_TIME = "last_edited_time"; 
export const ATTR_MMSI = "mmsi"; // array
export const ATTR_NATIONALITY = "nationality"; // array
export const ATTR_NATIONAL_ID_NUMBER = "national_identity_number"; // array 
export const ATTR_OWNER = "owner"; // array
export const ATTR_PASSPORT_NUM = "passport_num"; // array
export const ATTR_PRIMARY_COUNTRY = "primary_country"; // array
export const ATTR_POB = "place_of_birth"; // array
export const ATTR_PHONE_NUMBER = "phone_number"; // array
export const ATTR_REGISTRATION_DATE = "registration_date"; // array
export const ATTR_REGISTRATION_NUM = "registration_num"; // array
export const ATTR_SANCTIONED = "sanctioned";
export const ATTR_SANCTIONED_AUTHORITY = "sanction_authority"; // array
export const ATTR_SANCTIONED_PROGRAM = "sanction_program"; // array
export const ATTR_SANCTIONED_STATUS = "sanctioned_status";
export const ATTR_SOURCES = "sources";
export const ATTR_STATUS = "status";
export const ATTR_TITLE = "title";
export const ATTR_UNIFIED_SOCIAL_CREDIT_CODE = "unified_social_credit_code"; // array 
export const ATTR_UN_PERM_REF_NUM = "UN_perm_ref_num"; // array
export const ATTR_US_ENTITY_NUM = "US_entity_num"; // array
export const ATTR_VESSEL_TYPE = "vessel_type"; // array 
export const ATTR_WEBSITE = "website";
export const ATTR_YEAR_BUILT = "year_built"; // array 

//
// Internal / Non-Display Entity Attributes
//
export const ATTR_ARANGO_ID = "arango_id";
export const ATTR_DATA = "data";
export const ATTR_EDGES = "edges";
export const ATTR_ENTITY = "entity";
export const ATTR_GOOGLE_TRANSLATE = "googleTranslate";
export const ATTR_LANG = "lang";
export const ATTR_ORIG_FULL_TEXT = "originalFullText";

//
// Derived Entity Attributes
//
export const ATTR_SME_VERIFIED = "sme_verified";
export const ATTR_PLA_AFFILIATED = "pla_affiliated";
export const ATTR_CCP_AFFILIATED = "ccp_affiliated";
export const ATTR_LAST_EDITED_TIME_STR = "last_edited_time_str"; 

//
// Entity Attribute Values
//
export const VAL_STATUS_APPROVED = "Approved";
export const VAL_STATUS_AWAITING_APPROVAL = "Awaiting Approval";
export const VAL_SOURCES_FILE_LINK = "fileLink";
export const VAL_SOURCES_FILENAME = "filename";
export const VAL_SOURCES_LINK = "sourceUrl";

//
// Entity Affiliation Types
//
const AFF_TYPE_AFFILIATION = "Affiliation";
const AFF_TYPE_BRANCH = "Branch";
const AFF_TYPE_BOARD_MEMBER = "Board member";
const AFF_TYPE_COLLABORATOR = "Collaborator";
const AFF_TYPE_EMPLOYMENT = "Employment";
const AFF_TYPE_FOUNDER = "Founder";
const AFF_TYPE_FUNDER = "Funder";
const AFF_TYPE_LEADER = "Leader";
const AFF_TYPE_MANAGIN_ORG = "Managing organization";
const AFF_TYPE_MEMBER = "Member";
const AFF_TYPE_OPERATED_BY = "Operated by";
const AFF_TYPE_ORGANIZER = "Organizer";
const AFF_TYPE_RESEARCH_UNIT = "Research unit";
const AFF_TYPE_SHAREHOLDER = "Shareholder";
const AFF_TYPE_SUBORDINATE = "Subordinate";
const AFF_TYPE_SUPPLIER = "Supplier";
const AFF_TYPE_SUPPORTER = "Supporter";
const AFF_TYPE_SUPPORTS = "Supports";
const AFF_TYPE_VESSEL_OPERATOR = "Vessel operator";

export const ENTITY_AFFILIATION_TYPES = [
  AFF_TYPE_AFFILIATION,
  AFF_TYPE_BRANCH,
  AFF_TYPE_BOARD_MEMBER,
  AFF_TYPE_COLLABORATOR,
  AFF_TYPE_EMPLOYMENT,
  AFF_TYPE_FOUNDER,
  AFF_TYPE_FUNDER,
  AFF_TYPE_LEADER,
  AFF_TYPE_MANAGIN_ORG,
  AFF_TYPE_MEMBER,
  AFF_TYPE_OPERATED_BY,
  AFF_TYPE_ORGANIZER,
  AFF_TYPE_RESEARCH_UNIT,
  AFF_TYPE_SHAREHOLDER,
  AFF_TYPE_SUBORDINATE,
  AFF_TYPE_SUPPLIER,
  AFF_TYPE_SUPPORTER,
  AFF_TYPE_SUPPORTS,
  AFF_TYPE_VESSEL_OPERATOR,
];

export const ENTITY_AFFILIATION_DESCRIPTIONS = {
  [AFF_TYPE_AFFILIATION]: "is affiliated with",
  [AFF_TYPE_BRANCH]: "is a branch of",
  [AFF_TYPE_BOARD_MEMBER]: "is a board member of",
  [AFF_TYPE_COLLABORATOR]: "is a collaborator of",
  [AFF_TYPE_EMPLOYMENT]: "is employed by",
  [AFF_TYPE_FOUNDER]: "is a founder of",
  [AFF_TYPE_FUNDER]: "is a funder of",
  [AFF_TYPE_LEADER]: "is a leader of",
  [AFF_TYPE_MANAGIN_ORG]: "is a managing organization of",
  [AFF_TYPE_MEMBER]: "is a member of",
  [AFF_TYPE_OPERATED_BY]: "is operated by",
  [AFF_TYPE_ORGANIZER]: "is an organizer of",
  [AFF_TYPE_RESEARCH_UNIT]: "is a research unit of",
  [AFF_TYPE_SHAREHOLDER]: "is a shareholder of",
  [AFF_TYPE_SUBORDINATE]: "is a subordinate of",
  [AFF_TYPE_SUPPLIER]: "is a supplier of",
  [AFF_TYPE_SUPPORTER]: "is a supporter of",
  [AFF_TYPE_SUPPORTS]: "supports",
  [AFF_TYPE_VESSEL_OPERATOR]: "is a vessel operator of",

}

//
// General Constants
//

export const EMPTY_IND = "-";

// Returns a boolean indicating if an attribute ID is displayed in a dedicated area 
// of the UI (false) or should be treated as an "other" attribute (true) for generic display
export const isOtherAttr = (attrId) => {
  switch (attrId) {
    case ATTR_ADDRESS:
    case ATTR_ADDRESS_EN:
    case ATTR_AKA:
    case ATTR_AKA_EN:
    case ATTR_CALL_SIGN:
    case ATTR_CATEGORIES:
    case ATTR_CCP_AFFILIATED:
    case ATTR_CREATION_SOURCE:
    case ATTR_CITIZENSHIP:
    case ATTR_DETAILS:
    case ATTR_ENTITY_TYPE:
    case ATTR_DOB:
    case ATTR_EMAIL:
    case ATTR_FKA:
    case ATTR_FKA_EN:
    case ATTR_FLAG_STATE:
    case ATTR_FORMER_FLAG_STATE:
    case ATTR_IMO:
    case ATTR_LABEL:
    case ATTR_LABEL_EN:
    case ATTR_LAST_EDITED_TIME:
    case ATTR_LAST_EDITED_TIME_STR:
    case ATTR_MMSI:
    case ATTR_NATIONALITY:
    case ATTR_OWNER:
    case ATTR_PHONE_NUMBER:
    case ATTR_PLA_AFFILIATED:
    case ATTR_PRIMARY_COUNTRY:
    case ATTR_POB:
    case ATTR_REGISTRATION_DATE:
    case ATTR_SANCTIONED:
    case ATTR_SANCTIONED_AUTHORITY:
    case ATTR_SANCTIONED_PROGRAM:
    case ATTR_SANCTIONED_STATUS:
    case ATTR_SME_VERIFIED:
    case ATTR_SOURCES:
    case ATTR_STATUS:
    case ATTR_TITLE:
    case ATTR_VESSEL_TYPE:
    case ATTR_WEBSITE:
    case ATTR_YEAR_BUILT:
      return false;
    default:
      return true;
  }
}

export const isDisplayAttr = (attrId) => {
  switch (attrId) {
    case ATTR_ARANGO_ID:
    case ATTR_EDGES:
    case ATTR_ENTITY:
    case ATTR_DATA:
    case ATTR_ID:
    case ATTR_ORIG_FULL_TEXT:
    case ATTR_GOOGLE_TRANSLATE:
    case ATTR_LANG:
      return false;
    default:
      return true;
  }
}


// Colors
export const COLORS = {
  errorTextColor: darkUI => darkUI ? "#C66173" : "#A7001E",
	exoInsightsTextColor: darkUI => darkUI ? vars.exoveraGreen : vars.exoveraDarkGreen,
  noResultsTextColor: darkUI => darkUI ? vars.sky_2 : vars.text_2,
  retryButtonColor: darkUI => darkUI ? vars.cerulean_3 : vars.cerulean_2,
  retryButtonBgColor: darkUI => darkUI ? vars.charcoal_0_9 : "#fff",
  retryButtonHoverColor: darkUI => darkUI ? vars.cerulean_2 : vars.cerulean_1,
  retryButtonBgHoverColor: darkUI => darkUI ? vars.charcoal_0_8 : vars.blueGrey_0_5,
  bgColor: darkUI => darkUI ? vars.charcoal_1 : "#ffffff",
  popoverColor: darkUI => darkUI ? vars.charcoal_0_8 : "#ffffff",
	itemLabelColor: darkUI => darkUI ? vars.sky_1 : vars.grey_4_7,
	itemValueColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3_7,
	itemIconColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3_5,
  popoverHeaderTextColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3,
  popoverHeaderIconColor: darkUI => darkUI ? vars.sky_2 : vars.grey_2_5,
  panelBgColor: darkUI => darkUI ? "rgba(25, 32, 53, 0.8)" : "rgba(255, 255, 255, 0.8)",
  UnderlineFadeColor: darkUI => darkUI ? "rgba(26, 33, 54, 0.8)" : "rgba(254, 254, 254, 0.8)",
  dividerColor: darkUI => darkUI ? vars.grey_4_3 : "#FBFBFB",
  tabIndColor: darkUI => darkUI ? vars.cerulean_1 : vars.cerulean_2,
  // panelBgColor: darkUI => darkUI ? "rgba(31, 39, 61, 0.9)" : "rgba(255, 255, 255, 0.9)",
  // dividerColor: darkUI => darkUI ? vars.grey_4 : "#FBFBFB",
  // panelBgColor: darkUI => darkUI ? vars.charcoal_1 : "#ffffff",
  panelBorderColor: darkUI => darkUI ? vars.charcoal_3 : "rgba(0,0,0,0.2)",
  nodePingColor: darkUI => darkUI ? vars.red_1 : vars.red_1,
  tooltipBgColor: darkUI => darkUI ? vars.grey_3 : vars.blueGrey_2,
  tooltipTextColor: darkUI => darkUI ? vars.sky_2 : vars.grey_3,
}

export const PANEL_HEADER_HEIGHT = 34;
export const PANEL_PADDING = 10;
export const PANEL_SPACING = 5;
export const PANEL_BORDER = 1;

// DOM
export const SCROLL_ID = "entity-view-scroll";